import {
  StyleSheet,
  View,
  Image,
  TouchableHighlight,
} from '../base_components';
import React from 'react';

const styles = StyleSheet.create({
  closeButton: {
    flexDirection: 'row',
    overflow: 'hidden',
    justifyContent: 'center',
    alignItems: 'center',
  },
  highlight: {
    flex: 1,
    alignSelf: 'stretch',
    borderRadius: '0.3em',
    backgroundColor: 'rgba(0,0,0,0.2)',

    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
  },
  icon: {
    margin: '0.4em',
    flex: 1,
    alignSelf: 'stretch',
  },
});

const CLOSE_IMG = require('../../assets/img/close_white.png');

export default class CloseButton extends React.PureComponent<any> {
  render() {
    const { style, onPress } = this.props;

    return (
      <View style={[styles.closeButton, style]}>
        <TouchableHighlight
          style={styles.highlight}
          underlayColor='blue'
          onPress={onPress}
        >
          <Image style={styles.icon} source={CLOSE_IMG} />
        </TouchableHighlight>
      </View>
    );
  }
}
